enum IABCategory {
  IAB1 = 'IAB1',
  IAB2 = 'IAB2',
  IAB3 = 'IAB3',
  IAB4 = 'IAB4',
  IAB5 = 'IAB5',
  IAB6 = 'IAB6',
  IAB7 = 'IAB7',
  IAB8 = 'IAB8',
  IAB9 = 'IAB9',
  IAB10 = 'IAB10',
  IAB11 = 'IAB11',
  IAB12 = 'IAB12',
  IAB13 = 'IAB13',
  IAB14 = 'IAB14',
  IAB15 = 'IAB15',
  IAB16 = 'IAB16',
  IAB17 = 'IAB17',
  IAB18 = 'IAB18',
  IAB19 = 'IAB19',
  IAB20 = 'IAB20',
  IAB21 = 'IAB21',
  IAB22 = 'IAB22',
  IAB23 = 'IAB23',
  IAB24 = 'IAB24',
  IAB25 = 'IAB25',
  IAB26 = 'IAB26',
}

export default IABCategory;
